<div class="username-configuration-dialog">
  <h2 class="dialog-title">Username Configuration</h2>

  <form [formGroup]="usernameConfigForm" class="dialog-form">
    <mat-form-field appearance="outline" class="dialog-field">
      <mat-label>New Run Username (Comma Separated)</mat-label>
      <input matInput type="text" formControlName="userName" placeholder="user1,user2,user3" />
      <mat-error *ngIf="usernameConfigForm.get('userName').invalid && usernameConfigForm.get('userName').touched">
        New Run Username is required
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="dialog-field">
      <mat-label>Failed Run Username (Comma Separated)</mat-label>
      <input matInput type="text" formControlName="failedUserName" placeholder="user1,user2,user3" />
      <mat-error *ngIf="usernameConfigForm.get('failedUserName').invalid && usernameConfigForm.get('failedUserName').touched">
        Failed Run Username is required
      </mat-error>
    </mat-form-field>
  </form>

  <div class="dialog-actions">
    <app-common-button
      label="Save"
      title="Save"
      [buttonId]="1111"
      [critical]="false"
      width="130px"
      height="34px"
      (clicked)="save()"
    >
    </app-common-button>
    <app-common-button
      label="Cancel"
      title="Cancel"
      [buttonId]="1111"
      [critical]="false"
      width="130px"
      height="34px"
      (clicked)="cancel()"
    >
    </app-common-button>
  </div>
</div>